// Utils
import { useEventDispatch } from 'utils'
import { ErrorHandler } from 'modules/tracing'

// Local utils
import { handleEmptiedWorkspaceTrash } from '../handlers'

// Types
import { useEmptiedWorkspaceTrashSubscription } from 'gqlTypes'

import { SubscriptionEventHandler } from './types'

// Types
export interface EmptiedWorkspaceTrashPayload {
  workspaceIdentifier: string
}

declare module 'utils' {
  export interface EventsMap {
    emptiedWorkspaceTrash: EmptiedWorkspaceTrashPayload
  }
}

export interface UseEmptiedWorkspaceTrashProps {
  /**
   * handler which is called _before_ share is removed/added from/to the cache
   * it is possible to use this handler to update the UI state if it is
   * necessary
   */
  onEmptiedWorkspaceTrash?: SubscriptionEventHandler<EmptiedWorkspaceTrashPayload>
}

export const useEmptiedWorkspaceTrash = (
  props: UseEmptiedWorkspaceTrashProps = {}
) => {
  const { onEmptiedWorkspaceTrash } = props
  const dispatchEvent = useEventDispatch('emptiedWorkspaceTrash')

  useEmptiedWorkspaceTrashSubscription({
    onSubscriptionData: ({ subscriptionData, client }) => {
      const workspaceIdentifier =
        subscriptionData.data?.emptiedWorkspaceTrash.workspaceIdentifier

      if (!workspaceIdentifier) {
        ErrorHandler.shouldNeverHappen(
          `missing emptiedWorkspaceTrash payload, ${JSON.stringify(
            subscriptionData
          )}`
        )
        return
      }

      try {
        onEmptiedWorkspaceTrash?.({ workspaceIdentifier, client })
      } catch (error) {
        ErrorHandler.shouldNeverHappen(
          `onEmptiedWorkspaceTrash should not throw errors, ${JSON.stringify(
            error
          )}`
        )
      } finally {
        handleEmptiedWorkspaceTrash({
          cache: client,
          identifier: workspaceIdentifier,
        })
        dispatchEvent({ workspaceIdentifier })
      }
    },
  })
}
